export default __webpack_public_path__ + "static/zaru_collages_v6-4-c65e6573ff6b87847d664070d2d7735e.png";